<template>
  <section id="leftContent" class="flex-column align-center">
    <div class="context-top text-center">
      <h5 class="title text-center capitalize">{{step.title}}</h5>
      <h3 class="step-context text-center capitalize">{{step.context}}</h3>
      <p v-if="route.name === 'Step2'" class="ex-step-context font-gothic">※ 微妙な形状はシミュレーションが難しく特にソフトフラットは実際と異なります。不安な方はサンプルをご請求ください。</p>
      <p v-if="route.name === 'Step6' || route.name === 'Step7'" class="ex-step-context font-gothic">※ 選択不要の場合はスキップしてください。</p>
      <p v-if="route.name === 'Step8'" class="ex-step-context font-gothic">※ 内石を留める位置はお任せください。<br>位置のご希望がある場合はオーダー時にご指定ください。<br>※ 選択不要の場合はスキップしてください。</p>
      <p v-if="route.name === 'Step9'" class="ex-step-context font-gothic">※ 刻印はシミュレーション画像には表示されません。<br>最終お見積もり画面でご確認ください。<br>※ 選択不要の場合はスキップしてください。</p>
      <button @click.stop="toggleDialog(true)" class="button transition oval pointer">{{step.btnText}}</button>
    </div>
    <div class="flex justify-start context-bottom">
      <ul class="flex-wrap for-pc">
        <li><span class="capitalize">性別:</span> <span class="capitalize">{{query}},</span></li>
        <li v-for="(item, idx) in results" :key="idx" >
          <span class="capitalize">{{ "step."+item.step }}:</span>
          <span class="capitalize">{{item.name+getDiamondColor(item)}},</span>
        </li>
      </ul>
    </div>
    <right-content class="show" />
  </section>
</template>

<script>
import useToggleDialog from "@/modules/moduleA/helpers/useToggleDialog";
import {useStore} from "vuex";
import {computed, ref} from "vue";
import {useRoute} from "vue-router";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import RightContent from "@/modules/moduleA/components/contents/RightContent";
export default {
  name: "LeftContent",
  components: {RightContent},
  props:{
    step:Object,
  },
  setup(){
    const store = useStore()
    const route = useRoute()
    const query = ref(route.query.gender)
    const {toggleDialog} = useDialogBuilder();

    const results = computed(() => {
      return store.state.moduleA.results;
    })
     const findStep = (id) => {
      return results.value.find(item => {
        return item.step === id
      })
    }
    const getDiamondColor = (item) =>{
      let ret = ''
      if(item.step===7){
        //console.log(item)
        //let ob = findStep(7)
        if(findStep(7).option){
          let o = ''
          if(findStep(7).option === 'black'){
            o = 'ブラック'
          }else if(findStep(7).option === 'blue'){
            o = 'ブルー'
          }else if(findStep(7).option === 'brown'){
            o = 'ブラウン'
          }
          ret = ", ダイヤの色: "+o
        }else if(!findStep(7).option && findStep(7).tab === 1 && !['taiyoboriBase','hoshiboriBase'].includes(findStep(7).val)){
          ret = ", ダイヤの色: 透明"
        } 
      }
      return ret
    }

    return {
      toggleDialog, query, results, route, 
      findStep,getDiamondColor
    };

  }
}
</script>

<style scoped>
#leftContent {
  width: 40%;
  height: 416px;
  max-height: 416px;
}
#leftContent > .context-top {
  padding-top: 70px;
}
#leftContent > .context-top > h5.title{
  margin-bottom: 10px;
}
#leftContent > .context-top > h5.title,
#leftContent > .context-top > h3.step-context {
  font-weight: 300;
}
#leftContent > .context-top > .context-top > h5.title {
  margin-bottom: 10px;
}
#leftContent > .context-top > h3.step-context {
  margin-bottom: 40px;
}
#leftContent > .context-top > .ex-step-context {
  font-size: .8rem;
  margin-bottom: 10px;
  color: #171717;
  text-align: left;
  padding: 0 10px;
  margin-top: -10px;
  line-height: 1.3;
}
#leftContent > .context-top > button.button {
  height: 50px;
  background-color: white;
  color: black;
  width: 224px;
  font-size: .9rem;
  border: 1px solid #171717;
  margin-bottom: 10px;
}
#leftContent > .context-top > button.button:hover {
  border-color: #ffffff;;
  transform: translateY(-5px);
  background-color: #1e272e;
  color: white;
  box-shadow: 0 1px 11px rgba(0, 0, 0, .2);
}

#leftContent > .context-bottom  {
  width: 100%;
  margin-top: auto;
  padding: 0 10px;
}
#leftContent > .context-bottom > ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
#leftContent > .context-bottom > ul > li{
  margin-right: 10px;
  color: gray;
  font-size: 1rem;
}
#leftContent > .context-bottom > ul > li > span:nth-child(1){
  font-size: .9rem;
  margin-right: 5px;
}

#leftContent .for-pc {
  display: flex;
}
#leftContent .for-sp {
  display: none;
}
@media screen and (max-width: 736px) {
  #leftContent .for-pc {
    display: none !important;
  }
  #leftContent .for-sp {
    display: block;
    margin: 0;
    padding: 0;
  }
}
</style>
